var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDshChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_chart",
    "data-name": "vuesax/bold/chart",
    transform: "translate(-428 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chart",
    transform: "translate(428 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H18V18H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M14.063,1.125H.563A.567.567,0,0,1,0,.563.567.567,0,0,1,.563,0h13.5a.567.567,0,0,1,.563.563A.567.567,0,0,1,14.063,1.125Z",
    transform: "translate(1.688 15.938)",
    fill: "#5b7891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M1.95,0H.75A.752.752,0,0,0,0,.75V7.215a.752.752,0,0,0,.75.75h1.2a.752.752,0,0,0,.75-.75V.75A.747.747,0,0,0,1.95,0Z",
    transform: "translate(2.25 6.285)",
    fill: "#5b7891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M1.95,0H.75A.752.752,0,0,0,0,.75V9.608a.752.752,0,0,0,.75.75h1.2a.752.752,0,0,0,.75-.75V.75A.752.752,0,0,0,1.95,0Z",
    transform: "translate(7.65 3.893)",
    fill: "#5b7891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M1.95,0H.75A.752.752,0,0,0,0,.75V12a.752.752,0,0,0,.75.75h1.2A.752.752,0,0,0,2.7,12V.75A.752.752,0,0,0,1.95,0Z",
    transform: "translate(13.05 1.5)",
    fill: "#5b7891"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDshChart);
export default __webpack_public_path__ + "static/media/dsh-chart.ed34cd36519b917c009fc8132682c5b6.svg";
export { ForwardRef as ReactComponent };